import { render, staticRenderFns } from "./itemReleaseUndoList.vue?vue&type=template&id=4c03a136&scoped=true"
import script from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
export * from "./itemReleaseUndoList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseUndoList.vue?vue&type=style&index=0&id=4c03a136&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c03a136",
  null
  
)

export default component.exports